<template>
	<div id="carsView">
		<div id="carsViewContainer">
			
			<context-menu ></context-menu>
			<share></share>
			
			<div id="accounts" v-on:click="$store.state.activeWindowPartID = '#accounts'">
				<ul>
					<li v-bind:class="{ active: $store.state.activeAccountID == '' }">
						<a href="" data-account="" v-on:click="filterList" data-folderType="inbox" class="all"><span class="accname">ALLE</span> <span class="unread">{{unreadCarsSum}}</span></a>					
					</li>										
					<li v-for="property in properties" v-bind:class="{ active: $store.state.activeAccountID == property.abk, openUl: $store.state.activeAccountID == property.abk }">
						<a class="downToggle" v-on:click="downToggle" href="#" v-bind:data-account="property.abk" v-bind:data-accountID="property.id"><i class="fa fa-chevron-right"></i><i class="fa fa-chevron-down"></i></a><a href="" v-bind:data-accountID="property.id" v-bind:data-account="property.abk" v-bind:data-folderID="property.folders.filter( folder => { return folder.cat_type == 'inbox'} )[0].id" data-folderType="inbox"  v-on:click="filterList"><span class="accname">{{property.abk}}</span><span class="unread">{{ unreadCars.length > 0 && unreadCars.filter( puc => { return puc.property_id == property.id }).length >0 ? unreadCars.filter( puc => { return puc.property_id == property.id })[0].count : 0}}</span></a><a class="contextmenu" v-on:click="ContextMenu" href="#" v-bind:data-account="property.abk" v-bind:data-accountID="property.id"><i class="fa fa-ellipsis-v" aria-hidden="true"></i></a>
						<ul>
							<li v-for="folder in property.folders" v-bind:class="{ active: $store.state.activeFolder.id ==  folder.id  }">
								<a  
									v-bind:data-account="property.abk" v-bind:data-folderID="folder.id" v-bind:data-folderType="folder.cat_type" v-on:click="filterList" href="" 
										droppable="true" v-on:dragenter="dragenter" v-on:dragleave="dragleave" v-on:dragover="dragover" v-on:drop="dropIt">{{ folder.cat_name }}</a>	
							</li>
						</ul>
					</li>										
				</ul>			
			</div>

			<car-list :cars="cars" :cars.sync="cars" v-on:search-cars="searchCars"></car-list>				
		</div>
	</div>
</template>

<script>
	
import CarList from '@/components/Cars/CarList';
import ContextMenu from '@/components/ContextMenu/ContextMenu';
import Share from '@/components/Share/Share';
//import Property from '@/components/Properties/Property';
	
export default {
	name: "CarsView",
	components: {
		CarList,
		ContextMenu,
		Share
		//Property
	},
	data() {
	    return {
	      		cars: [],
	      		properties: [],
	      		unreadCars: [],
	      		unreadCarsSum: 0	      		
			  }
	},
	sockets: {
		
		getUnreadCars( unreadCars ){


			this.unreadCars = unreadCars;
			var c = 0;
			
			if(unreadCars.length > 0)
			unreadCars.forEach( function(p){
				c = c + p.count
			});
			this.unreadCarsSum = c;
			
			
			//console.log(this.unreadCarsSum)
		},
		
		syncProperties( properties ){
			
			this.properties = [];
			
		    if( properties.length > 0) {	
			    
			    		

			properties.forEach( function(property){

			 //console.log(property);   

				//console.log(  JSON.parse( "[" + property + "]") )

				try {
				      var folders = JSON.parse( "[" + property.folders + "]" );
				} catch (e) {
				    console.log(e);
				    //console.log( property.folders )
				}

				if( folders ) {
					property.folders = _.sortBy(folders, ['pos']); ;
				    }
				this.properties.push( property );
			}, this);



			}
		},
		
		
		
	    syncCars( cars ) {
		    //console.log( cars );
		    this.cars = [];
		    
		    if( cars.length > 0) {
			    cars.forEach(function(car, index, array){

				        try {
						        var car_j = JSON.parse(car.car_json);
						    } catch (e) {
						        console.log(e);
						        console.log( car.vorgangsnummer )
						    }
				    if( car_j ) {					    
					    
						// Fotos vorbereiten für Lightbox					    
						car_j.images = []
					    if( typeof car_j.fotos_json == 'object') {
								if( car_j.fotos_json.length > 0) {
							  		car_j.fotos_json.forEach(function(foto){
								  		car_j.images.push({ src: foto, title:'' });	
							  		})
					  			}	
					  	}

				    	this.cars.push( _.merge(car, car_j) );
				    }
			    }, this);
			    
				if( this.$store.state.editingCarID == 0 &&  this.cars.length > 0) {
					 this.$store.commit('updateEditingCarID',  this.cars[ this.cars.length - 1 ].vorgangsnummer )
				}
			}			
    	},
    	
    	
    	updateCarValue( update ){
	    	
	    	console.log('value update coming');
	    	console.log( update );
			var c = this.cars.filter( car => { return car.id == update.id });
	    	console.log( c );
	    	this.$set(c[0], update.field, update.value)
    	},
    	    	
    	updateCar(uCarData){



						
			var uCar = _.merge(uCarData.car, JSON.parse(uCarData.car.car_json)), //uCarData.car,
				c = this.cars.filter( car => { return car.vorgangsnummer == uCar.vorgangsnummer }),
				updte = false;

				uCar.images = []
			    if( typeof uCar.fotos_json == 'object') {
						if( uCar.fotos_json.length > 0) {
					  		uCar.fotos_json.forEach(function(foto){
						  		uCar.images.push({ src: foto, title:'' });	
					  		})
			  			}	
			  	}	    	


			//console.log(c);
			if( c.length > 0) {
				this.$set(this.cars, this.cars.indexOf( c[0] ), this._.merge(c[0], uCar ));
				//console.log( uCar.vorgangsnummer + ' vom Server aktualisiert');
				updte = true;
			} else { 
				
				console.log('new car in ' + uCarData.property )
				
				//if( this.$store.state.activeAccountID == uCarData.property || this.$store.state.activeAccountID == '')				
				this.cars.push( uCar ); 

				//console.log( uCar );
				//console.log('new car pushed');
				//console.log( this.cars.length ) 

			}

			this.$socket.emit('getUnreadCars', { } );

			this.$notify({
				  group: 'newcar',
				  title: (updte ? 'Update' : 'Neue Anfrage'),
				  text: uCar.vorgangsnummer + " " + uCar.marke + " " + uCar.modell + " " + uCar.baujahr + "<br>" + uCar.name ,
				  duration: 1500,
				  position: 'top center'
			})			
			
	    	
    	}
    },  
	methods: {
		
		downToggle: function(e){
			e.preventDefault();
			$(e.currentTarget).parent('li').toggleClass('openUl');	
		},
		
		searchCars: function(searchStr){
			console.log('start Search: ' + this.$store.state.searchQuery);
			this.$socket.emit('syncCars', { search: this.$store.state.searchQuery, account: this.$store.state.activeAccountID, folder: this.$store.state.activeFolder, unreadOnly: this.$store.state.showUnreadOnly } );
		},

	
		ContextMenu: function(e){
			this.$store.state.accountContext = { account: $(e.currentTarget).attr('data-account'), accountID: $(e.currentTarget).attr('data-accountID') };
			
			var self = this;
			$('#contextmenu').toggleClass('open').css({ top: $(e.currentTarget).offset().top -6, left: $(e.currentTarget).offset().left + 24  })
				.one('mouseenter', function(){ $(this).one('mouseleave', function() { $(this).removeClass('open'); self.$store.state.accountContext = {} ; }) });
		},
		
				
		/* Drag'n'Drop ----------------------------------------- */

		dragover: function(e){
			e.preventDefault()
			//console.log('dragover');
		},
		dragenter: function(e){ 
			e.preventDefault()
			//console.log(e); 
			//console.log('dragenter'); 
			$(e.currentTarget).addClass(' d_over')
		},
		dragleave: function(e) {
			e.preventDefault()
			//console.log('dragleave'); 
			$(e.currentTarget).removeClass(' d_over')			
		},

		dropIt: function(e){
			e.preventDefault()
			//console.log('drooooo'); 
			var folderID = $( e.currentTarget ).attr('data-folderID');
			var account = $( e.currentTarget ).attr('data-account');
			console.log( folderID + " "+ account);
			console.log( e.dataTransfer.getData('Text') );
			var car = this.$store.state.draggedCar
			car.category_id = folderID;
			console.log( car );		
			this.$socket.emit('saveCarValue', { update: { id: car.id, category_id: folderID }, quiet: 0 } );			
			//this.$socket.emit('updateCarCategory', { update: { id: car.id, new_category_id: folderID, account: account }, quiet: 0 } );
			
					
			$(e.currentTarget).removeClass(' d_over')									
		},
		
		
		
		filterList : function(e){
			e.preventDefault();
			//console.log(a);
			this.$store.state.activeAccountID = e.currentTarget.getAttribute('data-account');
			this.$store.state.activeFolder = { id: e.currentTarget.getAttribute('data-folderID'), cat_type : e.currentTarget.getAttribute('data-folderType') };
			this.$socket.emit('syncCars', { search: this.$store.state.searchQuery, account: this.$store.state.activeAccountID, folder: this.$store.state.activeFolder, unreadOnly: this.$store.state.showUnreadOnly } );
		},
/*
		checkKeyDown : function(e){		
								
				console.log(e);				
												
				if(this.$store.state.activeWindowPartID == '#previews') {
					if(e.keyCode == 8) {
						console.log(this.CarList);
						//this.$children('deleteCar', this.cars.filter( car => { return car.vorgangsnummer == this.$store.state.editingCarID }) );
						}
					if(e.keyCode == 40) {
						e.preventDefault();							
						//console.log('down')
						var c =  this.cars.filter( car => { return car.vorgangsnummer == this.$store.state.editingCarID });	
						var i = this.cars.indexOf( c[0] ) 	//$this.$store.state.editingCarID
						this.$store.commit('updateEditingCarID',  this.cars[i+1].vorgangsnummer )	    
						}
	
					if(e.keyCode == 38) {
						e.preventDefault()
						//console.log('up')
						var c =  this.cars.filter( car => { return car.vorgangsnummer == this.$store.state.editingCarID });	
						var i = this.cars.indexOf( c[0] ) 	//$this.$store.state.editingCarID
						this.$store.commit('updateEditingCarID',  this.cars[Math.max(i-1,0)].vorgangsnummer )	    
						}
				}
		}
*/


	},
	created: function(){		
		//var $this = this;
		//window.addEventListener('keydown', this.checkKeyDown)
	},
	destroyed: function() {
		//window.removeEventListener('keydown', this.checkKeyDown)
	},
	mounted: function(){
		this.$socket.emit('getUnreadCars', { } );
		this.$socket.emit('getProperties', { a: 'test' });
		this.$socket.emit('syncCars', { search: this.$store.state.searchQuery, account: this.$store.state.activeAccountID, folder: this.$store.state.activeFolder, unreadOnly: this.$store.state.showUnreadOnly } );
	}


		
}
</script>
